import * as Constants from './constants'
import * as Types from './types'

export const sendGa4Event = (event: Types.Event4) => ({type: Constants.SEND_EVENT_4, event})
